module.exports = __webpack_public_path__ + "static/img/hbMusic.e6ae0be9.png";